import script from "./HonorMinView.vue?vue&type=script&setup=true&lang=js"
export * from "./HonorMinView.vue?vue&type=script&setup=true&lang=js"

import "./HonorMinView.vue?vue&type=style&index=0&id=07d214e9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d214e9"]])

export default __exports__